import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import PortfolioSection from '../components/PortfolioSection';
import ContactSection from '../components/ContactSection';
import LocationSection from '../components/LocationSection';

function LandingPage() {
  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">Lewati ke konten</a>
      <Navbar />
      <main id="main-content">
        <HeroSection />
        <PortfolioSection />
        <ContactSection />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}

export default LandingPage;